var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import * as classNames from 'classnames';
import Divider from 'antd/lib/divider';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Icon from 'antd/lib/icon';
import 'antd/lib/divider/style/index.css';
import 'antd/lib/grid/style/index.css';
import InputName from './InputName';
import InputCode from './InputCode';
import InputScoreSystem from './InputScoreSystem';
import InputRoutes from './InputRoutes';
import InputDate from './InputDate';
import ButtonDeleteRound from './ButtonDeleteRound';
var selfStyle = require('./styles.scss');
var FormRoundItem = (function (_super) {
    __extends(FormRoundItem, _super);
    function FormRoundItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isVisible: !!_this.props.round.id,
        };
        _this.handleRemoveRound = _this.handleRemoveRound.bind(_this);
        return _this;
    }
    FormRoundItem.prototype.componentDidMount = function () {
        var _this = this;
        this.timer = window.setTimeout(function () {
            _this.setState({ isVisible: true });
        }, 0);
    };
    FormRoundItem.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
    };
    FormRoundItem.prototype.handleRemoveRound = function () {
        var _this = this;
        this.setState({ isVisible: false });
        this.timer = window.setTimeout(function () {
            _this.props.handleRemoveRound(_this.props.index);
        }, 200);
    };
    FormRoundItem.prototype.render = function () {
        var form = this.props.form;
        var index = this.props.index;
        var round = this.props.round;
        var isDisabled = this.props.isDisabled;
        var isCreatingRound = !(round && round.id);
        return (React.createElement("div", { className: classNames(selfStyle.deleteRound, (_a = {}, _a[selfStyle.isVisible] = this.state.isVisible, _a)) },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: 6 },
                    React.createElement(InputCode, { form: form, index: index, isDisabled: isDisabled, initialValue: round.code })),
                React.createElement(Col, { xs: 18 },
                    React.createElement("div", { className: selfStyle.deleteRoundRow },
                        React.createElement(InputName, { form: form, index: index, isDisabled: isDisabled, initialValue: round.name }),
                        React.createElement(ButtonDeleteRound, { index: index, round: round, isDisabled: isDisabled || index === 0, handleRemoveRound: this.handleRemoveRound })))),
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: 14 },
                    React.createElement(InputScoreSystem, { form: form, index: index, isDisabled: isDisabled || !isCreatingRound, initialValue: round.scoreSystem })),
                React.createElement(Col, { xs: 10 },
                    React.createElement(InputRoutes, { form: form, index: index, isDisabled: isDisabled || !isCreatingRound, initialValue: round.routeCount || 6 }))),
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: 24 },
                    React.createElement(InputDate, { form: form, index: index, isDisabled: isDisabled, utcOffset: this.props.utcOffset, timezoneDisplay: this.props.timezoneDisplay, initialValueStart: round.dateStart || (round.date && round.date[0]), initialValueEnd: round.dateEnd || (round.date && round.date[1]) }))),
            !this.props.isLast && (React.createElement(Divider, null,
                React.createElement(Icon, { type: 'arrow-down' }),
                " Promote athletes to ",
                React.createElement(Icon, { type: 'arrow-down' })))));
        var _a;
    };
    FormRoundItem.defaultProps = {
        handleRemoveRound: function () { },
    };
    return FormRoundItem;
}(React.Component));
export default FormRoundItem;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormCategoryPage/FormRound/FormRoundItem.tsx
// module id = 1175
// module chunks = 0